export default "__VITE_ASSET__DzGPaa8K__"